<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <mobile-module-content *ngIf="!isLoading && !is401 && !is404" title="{{ 'Documents'|translate }}" [mainActions]="mainActions">

        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource"
                   matSort>
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="name-cell cell-mobile-first">{{ 'Name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell cell-mobile-first">
                    <div><a (click)="onPreviewClicked(row)">{{ row.originalName }}</a></div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createDate">
                <mat-header-cell *matHeaderCellDef class="name-cell cell-mobile-middle">{{ 'CreatedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell cell-mobile-middle">
                    <div>{{ row.createDate|appDate:'dd.MM.yy' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell  mat-header-cell *matHeaderCellDef class="cell-right cell-mobile-action"></mat-header-cell>
                <mat-cell mat-cell *matCellDef="let row;  let i = index" class="cell-right cell-mobile-action">
                    <button
                        *ngIf="row.rights.delete"
                        mat-icon-button
                        [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button
                                [disabled]="!row.rights.download"
                                mat-menu-item
                                (click)="download(row)">
                            <mat-icon>cloud_download</mat-icon>
                            <span>{{ 'Download' | translate }}</span>
                        </button>
                        <button
                            [disabled]="!row.rights.delete"
                            mat-menu-item
                            (click)="onDeleteClicked(row)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'Delete' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>

        <mat-paginator #paginator
           [class.hidden]="dataSource.count == 0"
           [pageSizeOptions]="[10]"
           hidePageSize
           showFirstLastButtons
           [pageSize]="pageSize"
           [length]="totalSize"
           [pageIndex]="currentPage"
           (page)="onPaginateChange($event)">
        </mat-paginator>

    </mobile-module-content>
</mobile-page-content>

